// @ts-nocheck

/**
 * * `COLLECTING_CHILDREN` - Collecting Children
 * `GENERATING_PREVIEWS` - Generating Previews
 * `TEMPLATE_SELECTION` - Template Selection
 * `AWAITING_AUTH` - Awaiting Authentication
 * `CLAIMED` - Claimed
 * `EXPIRED` - Expired
 * `CANCELLED` - Cancelled
 */
export type StorefrontSessionStatusEnum =
  typeof StorefrontSessionStatusEnum[keyof typeof StorefrontSessionStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontSessionStatusEnum = {
  COLLECTING_CHILDREN: "COLLECTING_CHILDREN",
  GENERATING_PREVIEWS: "GENERATING_PREVIEWS",
  TEMPLATE_SELECTION: "TEMPLATE_SELECTION",
  AWAITING_AUTH: "AWAITING_AUTH",
  CLAIMED: "CLAIMED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
} as const;
